/**
 =========================================================
 * Material Dashboard 2 PRO React - v2.1.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
 * Copyright 2022 Creative Tim (https://www.creative-tim.com)

 Coded by www.creative-tim.com

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */

import checkout from "./form";
import eventDefault from "assets/images/defaults/event_default.jpg";

const {
  formField: { name, start_date, end_date, description, event_type, will_process, cover, address, city, state, lat, lon, website, twitter, facebook, instagram },
} = checkout;

const initialValues = {
  [name.name]: "",
  [start_date.name]: new Date(),
  [end_date.name]:  new Date(),
  [description.name]: "",
  [event_type.name]: 2,
  [will_process.name]: false,
  [cover.name]: eventDefault,
  [address.name]: "",
  [city.name]: "",
  [state.name]: "",
  [lat.name]: 38.7072954,
  [lon.name]: 35.5281562,
  [website.name]: "",
  [twitter.name]: "",
  [facebook.name]: "",
  [instagram.name]: "",
};
export default initialValues;
